import baseRoute from './baseRoute';
import MainPage from '@/views/MainPage.vue';
import ActiveCoursesPage from '@/views/main/ActiveCoursesPage.vue';
import FinishedCoursesPage from '@/views/main/FinishedCoursesPage.vue';

export default (guards = null) =>
  baseRoute(
    {
      path: '/home',
      component: MainPage,
      children: [
        {
          path: '',
          redirect: 'courses'
        },
        {
          path: 'courses',
          component: ActiveCoursesPage,
          meta: {
            title: 'Aktualne szkolenia',
            breadcrumbs: [
              {
                text: 'Aktualne szkolenia'
              }
            ]
          }
        },
        {
          path: 'finished-courses',
          component: FinishedCoursesPage,
          meta: {
            title: 'Zakończone szkolenia',
            breadcrumbs: [
              {
                text: 'Zakończone szkolenia'
              }
            ]
          }
        },
        {
          path: '*',
          redirect: 'courses'
        }
      ]
    },
    guards
  );
